export default "__VITE_ASSET__CawS54rL__"